import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { TEMPLATE } from "../../../consts/strings";

import {
  deletePlan,
  editPlan,
} from "../../../reducers/matrixProfile/thunkActions";
import { getSelectedMatrixProfile } from "../../../reducers/matrixProfile/selectors";
import { editPlanModalOpenSelector } from "../../../reducers/ownApp/selectors";

import { View } from "../../Base";
import { Modal } from "../Modal";
import { ConfirmDialog } from "../../ConfirmDialog";
import { EditPlanModalActions } from "./EditPlanModalActions";
import { EditPlanModalContent } from "./EditPlanModalContent";

export const EditPlanModal = ({ open, onClose, profile }) => {
  const [newName, setNewName] = useState();
  const [confirmDeleteOpened, setConfirmDeleteOpened] = useState(false);
  const [isNameValid, setIsNameValid] = useState(true);
  const editPlanModalOpen = useSelector(editPlanModalOpenSelector);
  const selectedProfile = useSelector(getSelectedMatrixProfile);

  const dispatch = useDispatch();

  useEffect(() => {
    if (editPlanModalOpen) {
      // Reset values when modal is opened
      setNewName(profile.templateName);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editPlanModalOpen]);

  const onSave = () => {
    dispatch(editPlan({ name: newName, templateId: profile.templateId }));
  };

  const onDelete = () => {
    setConfirmDeleteOpened(true);
  };

  const onConfirmDelete = () => {
    setConfirmDeleteOpened(false);
    dispatch(deletePlan({ templateId: profile.templateId }));
  };

  return (
    <>
      <Modal
        open={open}
        onClose={onClose}
        title={
          selectedProfile && selectedProfile.type === TEMPLATE
            ? "Edit template"
            : "Edit dated plan"
        }
        content={
          <EditPlanModalContent
            name={newName}
            onNameChanged={(value) => {
              setNewName(value);
            }}
            setIsNameValid={setIsNameValid}
          />
        }
        actions={
          <EditPlanModalActions
            onSave={onSave}
            onDelete={onDelete}
            isNameValid={isNameValid}
          />
        }
        minWidth={500}
      />

      <ConfirmDialog
        open={confirmDeleteOpened}
        onConfirm={onConfirmDelete}
        onDecline={() => {
          setConfirmDeleteOpened(false);
        }}
      >
        <>
          <View>Are you sure?</View>
          <View>This will delete the Template permanently</View>
        </>
      </ConfirmDialog>
    </>
  );
};

export default EditPlanModal;
